import { render, staticRenderFns } from "./Pop-Img.vue?vue&type=template&id=38bcf6a6&scoped=true"
import script from "./Pop-Img.vue?vue&type=script&lang=js"
export * from "./Pop-Img.vue?vue&type=script&lang=js"
import style0 from "./Pop-Img.vue?vue&type=style&index=0&id=38bcf6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcf6a6",
  null
  
)

export default component.exports